var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_89_1399)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.80481,
    y: 0.930664,
    width: 30.4228,
    height: 30.4026,
    rx: 5,
    fill: "#1E1E1E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7392 11.7553C25.0869 12.0118 24.3861 12.1851 23.6494 12.2634C24.4095 11.8598 24.9782 11.2245 25.2494 10.4762C24.5352 10.8526 23.7535 11.1176 22.9384 11.2596C22.3903 10.7402 21.6642 10.396 20.873 10.2803C20.0818 10.1646 19.2697 10.284 18.5628 10.6198C17.8558 10.9557 17.2937 11.4893 16.9635 12.1378C16.6333 12.7862 16.5536 13.5133 16.7368 14.206C15.2897 14.1416 13.874 13.8078 12.5816 13.2264C11.2893 12.6449 10.1491 11.8289 9.23517 10.8311C8.92266 11.3095 8.74298 11.8641 8.74298 12.4548C8.74263 12.9865 8.89019 13.5101 9.17257 13.9791C9.45495 14.4481 9.86342 14.848 10.3617 15.1434C9.78382 15.127 9.21866 14.9885 8.71329 14.7392V14.7808C8.71323 15.5266 9.00394 16.2494 9.53609 16.8266C10.0682 17.4039 10.8091 17.8 11.6328 17.9477C11.0967 18.0764 10.5347 18.0954 9.98908 18.0032C10.2215 18.6449 10.6742 19.206 11.2839 19.6081C11.8936 20.0101 12.6297 20.2329 13.3891 20.2452C12.0999 21.1433 10.5077 21.6305 8.86876 21.6283C8.57843 21.6284 8.28834 21.6134 8 21.5833C9.66367 22.5325 11.6003 23.0363 13.5782 23.0343C20.2735 23.0343 23.9337 18.1134 23.9337 13.8455C23.9337 13.7069 23.9298 13.5668 23.9228 13.4282C24.6347 12.9713 25.2493 12.4055 25.7376 11.7573L25.7392 11.7553Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_89_1399",
    x: -39.1952,
    y: -39.0693,
    width: 110.423,
    height: 110.403,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_89_1399"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_89_1399",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/Twitter Icon.6ace3be45e69e7d413a55c04fefe6870.svg";
export { ForwardRef as ReactComponent };